import { render, staticRenderFns } from "./PluginStarPrinterPrintersSubresource.vue?vue&type=template&id=624628c6&"
import script from "./PluginStarPrinterPrintersSubresource.vue?vue&type=script&lang=ts&"
export * from "./PluginStarPrinterPrintersSubresource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports